var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-breadcrumb',{attrs:{"items":_vm.allCrumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }